import { IoCheckmarkCircleOutline } from "react-icons/io5"
import { BiCoinStack } from "react-icons/bi"
import { IoLockClosedOutline } from "react-icons/io5"
import { BiLike } from "react-icons/bi"
import img1 from "../../../../assets/img/Services/OperationalExe/285.jpg"

import { TfiBarChartAlt } from "react-icons/tfi";
import { BiAdjust } from "react-icons/bi";
import { IoMdTrendingUp } from "react-icons/io";

export default function MainSection5() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
      <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div> 
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Resource Optimization
            </h1>
            <p className="text-lg text-gray-600">
            Resource optimization focuses on maximizing cloud resource efficiency to reduce costs while maintaining performance.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <TfiBarChartAlt className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Cost Reduction</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Optimize cloud resources to minimize wastage and lower operational costs.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <BiAdjust className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Performance Balance</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Ensure resource utilization is balanced with system performance requirements.
              </p>
            </div>

            {/* Feature 3 */} 
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <IoMdTrendingUp className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Efficient Scaling</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Scale resources dynamically to match demand without overspending on unused capacity.
              </p>
            </div>

            {/* Feature 4 */}
            {/* <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <BiLike className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">All in One</h3>
              </div>
              <p className="text-gray-600 text-sm">
                All-in-one solution ensures that you can easily manage your financial needs.
              </p>
            </div> */}
          </div>
        </div>

      
      </div>
    </div>
  )
}